module.exports = __webpack_public_path__ + "static/jade12-532cb43d4272c4ad4ed523b53f47ea63.png";